import {getApiConfig, getManaging} from "../../utilities/backend";
import {PARTS} from "../../schemas/accessRightsModel";
import {hardCodeIsDeStefano} from "../../constants/fabricatorHardcode";
import {getCustomerInfo} from "../AddNewEntity/AddNewEntityActions";
import {getCurrentFabricatorId} from "../../utilities";
import {getVisualizerTypeFromSubscription} from "./jobEditPopup/jobEditPopupFunctions";

const getJobResponse = async (job) => {
  const {get} = getApiConfig('public/getBvJobData/' + job.id);
  const jobResponse = await get();
  console.log("jobResponse", jobResponse);
  return jobResponse && jobResponse.records && jobResponse.records[0] && jobResponse.records[0].data
};

export const getJobEditIframeUrl = async (editableQuote, asCustomer, auth, AR, language, editableQuoteShow = "", showEditable = "", signedRequestId = "", allSubscriptions = []) => {
//newquote/indexex?jobId=92047&version=3
  const {model} = document.kvConfig;
  const userId = (asCustomer && asCustomer.activeEntity) ? asCustomer.activeEntity.id : auth.userId;
  let subDomain = editableQuote.fabricatorInfo ? editableQuote.fabricatorInfo.subdomain : "";
  if (!subDomain) {
    subDomain = auth.subDomain || 'master';
    if (asCustomer && asCustomer.activeEntity && asCustomer.activeEntity.subDomain) {
      subDomain = asCustomer.activeEntity.subDomain;
    }
  }
  console.log("editableQuote", editableQuote);
  // const url = model.MasterApiUrl.split('://');
  // return url[0] + '://' + editableQuote.fabricatorSubDomain + '.' + url[1] +
  let fromTool = editableQuote.quotes[0].fromTool;
  let url = "";
  if (window.location.port === "9005") {
    url = "http://localhost:9007";
  } else if (getManaging() === "KitchenDB") {
    url = model.FabricatorApiUrl.toLowerCase().includes("quotekitchenandbath")
      ? "https://secure.quotecountertops.com/newquote/indexex"
      : "http://granitefabricatorsdirect.com/newquote/indexex"
  } else {
    url = model.FabricatorApiUrl + "/newquote/indexex"
  }

  const isClient = AR.isClient();
  const hide = isClient && !AR.isFabAdmin() && !AR.isSiteAdmin() ? "&hide=true" : "";
  const mode = isClient ? "" : "&mode=dashboard";
  const showEditableText = showEditable ? `&show=${editableQuoteShow}` : "";
  const sr = signedRequestId ? `&sr=${signedRequestId}` : "";

  var visualizerType = 1;
  console.log(editableQuote);
  const jobData = await getJobResponse(editableQuote);

  if (editableQuote.visualizerType) {
    visualizerType = editableQuote.visualizerType;
  } else if (isNewlyCreatedJob(jobData) && allSubscriptions.length === 1) {
    const fabId = getCurrentFabricatorId({auth, asCustomer});
    const profile = await getApiConfig(`Users/GetCustomerInfo/${fabId}/Fabricator/undefined`).get();
    if (profile && profile.toolSettings
      && profile.toolSettings[allSubscriptions[0]] && profile.toolSettings[allSubscriptions[0]].version) {
      const toolVersion = profile.toolSettings[allSubscriptions[0]].version;
      visualizerType = getVisualizerTypeFromSubscription(allSubscriptions[0], toolVersion);
      console.log("visualizerType!!", visualizerType);
    }
  }

  url = url +
    ((fromTool === 'KV4' || fromTool === 'DB' ? `?bv=false&version=4&visualizerType=${visualizerType}` : (editableQuote.quotes[0].fromBV ? "?bv=true&version=4" + (visualizerType !== 1 ? `&visualizerType=${visualizerType}` : ``) : "?version=3"))) + `${showEditableText}&jobId=${editableQuote.id}${mode}` +
    `&fabricatorId=${editableQuote.fabricatorId}&p=${userId}&saveQuote=${(AR.e(PARTS.SAVE_QUOTE) && !isClient) || (isClient && editableQuote.leadType === "Quote")}${hide + sr}`;

  if (!hardCodeIsDeStefano(subDomain)) {
    url += `&language=${language}`;
  }
  url = `${url}&jobBoard=1&fab_subdomain=${subDomain}`;

  if (jobData && (jobData.toolVersion >= 6 || (jobData.toolVersion === 5 && jobData.visualizerType === "kvScene"))) {
    url = `${url}&nav=${jobData.navigationType || "look"}`;
  }

  if (window.location.port === '9005') {
    console.log("url", url);
  }

  return url
}

/**
 * when the new customer is created - the system creates a job for him with only one userState property
 * @param jobResponse {object}
 * @param bvState {object}
 * @returns {boolean}
 */
export const isNewlyCreatedJob = (jobResponse, bvState) => {

  if (jobResponse && !bvState) {
    if (Array.isArray(jobResponse.records) && jobResponse.records.length) {
      const records = jobResponse.records.filter(record => record && record.data);
      if (records.length === 1) {
        bvState = records[0].data;
      }
    } else { // whoa, nothing there, so it's probably a brand new job, let's load default preset
      return true
    }
  }

  return bvState && (Object.keys(bvState).length === 1) && bvState.userState
}
